import verifyResponse from "@thelpers/verifyResponse"
import { getChargeInstanceDebtorPaymentDetail } from "../../../services/GET/getChargeInstanceDebtorPaymentDetail"
import { useCallback } from "react"
import { useAppSelector } from "@hooks/store"
import { getChargeInstanceDebtorDetail } from "../../../services/GET/getChargeInstanceDebtorDetail"

export const useComrpobantDetailPaymentServices = () => {
    const auth = useAppSelector(state => state.auth)

    const getChargeInstanceDebtorPaymentDetailService = useCallback(async ({ setLoading, charge_instance_id, place_id }) => {
        setLoading?.(true)
        const res = await getChargeInstanceDebtorPaymentDetail({ token: auth.idToken, charge_instance_id, place_id })
        const status = verifyResponse({ dataResponse: res.data, statusResponse: res.status, showToast: false })
        if (!status) {
            setLoading?.(false)
            throw new Error('Error in getChargeInstanceDebtorPaymentDetailService')
        }
        return res.data.data
    }, [auth])

    const getChargeInstanceDebtorDetailService = useCallback(async ({ setLoading, charge_instance_id, place_id }) => {
        setLoading?.(true)
        const res = await getChargeInstanceDebtorDetail({ token: auth.idToken, charge_instance_id, place_id })
        const status = verifyResponse({ dataResponse: res.data, statusResponse: res.status, showToast: false })
        if (!status) {
            setLoading?.(false)
            throw new Error('Error in getChargeInstanceDebtorDetailService')
        }
        return res.data.data
    }, [auth])

    return {
        getChargeInstanceDebtorPaymentDetailService,
        getChargeInstanceDebtorDetailService
    }
}